import React from "react"
import Task from "../../../../../../model2/task/task"
import UserIconNew from "../../../../../../gd-components/icons/user/user"

type Props = {
    task     : Task
    colWidth : number | undefined
}

// const debug = "FieldTaskUsers_CellIcons"
const debug = false

export default function FieldTaskUsers_CellIcons(props: Props) {
    const isOpen      = gd.const.systemStatus.isOpen(props.task.systemStatus)
    const users: any[] = _.map(props.task.users, (taskUser: any) => {
        return gd.session.users.get(taskUser.userId)!
    })
    const iconsToShow = props.colWidth ? Math.ceil((props.colWidth - 20) / 25) : 5

    const userIcon = (id: ID) => (
        <div key        = {id}
             className  = "ico">
            <UserIconNew
                className   = "user-icon"
                size        = "22"
                hint        = "up"
                userId      = {id}
            />
        </div>
    )

    const res: React.ReactNode[] = []
    const sortedUsers = _.sortBy(users, (user: any) => {
        return user?.name ?? ''
    })

    debug && console.log(debug, 'render', sortedUsers)

    if (users.length > iconsToShow) {
        if (props.task.actionRequiredUserId) {
            res.push(userIcon(props.task.actionRequiredUserId))
        }
        if (
            props.task.assignedToUserId
            && props.task.assignedToUserId !== props.task.actionRequiredUserId
        ) {
            res.push(userIcon(props.task.assignedToUserId))
        }
        /*if (
            (res.length < iconsToShow - 1)
            && props.task.createdByUserId !== props.task.actionRequiredUserId
            && props.task.createdByUserId !== props.task.assignedToUserId
            && props.task.createdByUserId
        ) {
            res.push(userIcon(props.task.createdByUserId))
        }*/

        let moreToShow = (iconsToShow - 1) - res.length
        _.each(sortedUsers, (user: any) => {
            if (
                moreToShow > 0
                // && user.id !== props.task.createdByUserId
                && user.id !== props.task.actionRequiredUserId
                && user.id !== props.task.assignedToUserId
            ) {
                res.push(userIcon(user.id))
                moreToShow--
            }
            return
        })

        const more: number = users.length - res.length
        if (more > 0) {
            res.push(
                <div key="more" className="ico">
                    <div className="ui5-counter circle-user">+{more}</div>
                </div>
            )
        }
    } else {
        if (props.task.actionRequiredUserId && isOpen) {
            res.push(userIcon(props.task.actionRequiredUserId))
        }
        if (
            props.task.assignedToUserId
            && props.task.assignedToUserId !== props.task.actionRequiredUserId
        ) {
            res.push(userIcon(props.task.assignedToUserId))
        }
        /*if (
            props.task.createdByUserId
            && props.task.createdByUserId !== props.task.actionRequiredUserId
            && props.task.createdByUserId !== props.task.assignedToUserId
        ) {
            res.push(userIcon(props.task.createdByUserId))
        }*/
        _.each(sortedUsers, (user: any) => {
            if (
                user.id !== props.task.assignedToUserId
                && user.id !== props.task.actionRequiredUserId
                // && user.id !== props.task.createdByUserId
            ) {
                res.push(userIcon(user.id))
            }
            return
        })
    }

    return <>{res}</>
}
